const mi = {
    data: function(){
        return {
            list: [],
            isAdding: false,
            show_title: ' [-]',
            isShowing: true,
            index: undefined,
            isViewSub: [],
            isAddSub: [],
            itemSub: [],
            subItems: []
        }
    },
    mounted: function() 
    {
        this.list = (this.$attrs.value)?this.$attrs.value:[];
    },
    methods: {
        add: function()
        {
            if(arguments[0] == 'undefined'){
                this.list.push( JSON.parse(JSON.stringify(this.current)) )
            }else{
                this.list[arguments[0]] = JSON.parse(JSON.stringify(this.current))
            }
            
            this.$attrs.value = this.list;
            this.$emit('input', this.$attrs.value);
            this.isAdding = false;
        },
        remove: function(index){
            if(typeof index != undefined){
                this.list.splice(index,1);
            }
        },
        cancel: function()
        {
            this.isAdding = false;
        },
        cancelSub: function()
        {
            Object.keys(this.isAddSub).forEach(function(key){
                this.isAddSub[key] = false;
            });
        },
        toggle: function()
        {
            if( this.isShowing )
            {
                this.isShowing = false;
                this.show_title = ' [+]';
            }
            else {
                this.isShowing = true;
                this.show_title = ' [-]';
            }
        }
    }
}

export default mi;